import { FormattedMessage } from "react-intl";
import SearchBox from "../../../../../Tree/SearchBox/SearchBox";

import styles from "./LinkableUsersTableHeader.module.css";

type LinkableUsersTableHeaderProps = {
  totalUsers?: number;
  totalSelected?: number;
  totalLinkedUsers?: number;
  searchText?: string;
  onSearchTextChange?: (text: string) => void;
  disabled?: boolean;
};

const LinkableUsersTableHeader = ({
  totalUsers,
  totalSelected,
  searchText,
  disabled,
  totalLinkedUsers,
  onSearchTextChange,
}: LinkableUsersTableHeaderProps) => {
  return (
    <header className="px-3 py-1 d-sm-flex align-items-center">
      <div className="flex-grow-1">
        <SearchBox
          disabled={disabled}
          value={searchText}
          onChange={onSearchTextChange}
        />
      </div>
      <div className="d-flex my-2 my-sm-0 justify-content-between">
        <div className="mx-2">
          <span>{totalUsers ?? 0}</span>
          &nbsp;
          <FormattedMessage id="MANAGEMENT.USERS" defaultMessage="Users" />
        </div>
        <div className={`${styles.totalSelected}`}>
          <strong>
            <span>{totalLinkedUsers ?? 0}</span>
            &nbsp;
            <FormattedMessage id="GLOBAL.LINKED" defaultMessage="Linked" />
          </strong>
        </div>
        <div className="mx-2">
          <span>{totalSelected ?? 0}</span>
          &nbsp;
          <FormattedMessage id="GLOBAL.SELECTED" defaultMessage="Selected" />
        </div>
      </div>
    </header>
  );
};

export default LinkableUsersTableHeader;
